import {
  AlertDialogHeader,
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { FC, useState } from 'react';
import { ContainerDetailsForm } from './ContainerDetailsForm';
import { useToast } from 'src/components/useToast';
import { trpc } from 'src/trpc';

export const NewContainerModal: FC = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const { successToast, errorToast } = useToast();
  const utils = trpc.useUtils();

  const handleSuccess = () => {
    successToast({
      title: 'Dumpster created',
      description: 'New dumpster has been successfully created',
    });
    setOpenDialog(false);

    // Invalidate the getAllContainers query to refresh the container list
    utils.admin.container.getAllContainers.invalidate();
  };

  const handleError = (error: Error) => {
    errorToast({
      title: 'Failed to create dumpster',
      description: error.message || 'An error occurred while creating the dumpster',
    });
  };

  return (
    <AlertDialog open={openDialog}>
      <AlertDialogTrigger asChild>
        <div>
          <Button onClick={() => setOpenDialog(true)} className="text-white w-full">
            Create New Dumpster
          </Button>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-left text-text-light">
            Create New Dumpster
          </AlertDialogTitle>
          <div className="mt-4" />
          <ContainerDetailsForm
            onSuccess={handleSuccess}
            onError={handleError}
            onStateChange={(state) => setIsFormValid(state.isValid)}
          >
            <div className="flex flex-row justify-end gap-4 mt-4">
              <div>
                <AlertDialogCancel
                  onClick={() => setOpenDialog(false)}
                  className="w-full text-muted mt-0"
                >
                  Cancel
                </AlertDialogCancel>
              </div>
              <div>
                <Button disabled={!isFormValid} className="w-full text-white" type="submit">
                  Create Dumpster
                </Button>
              </div>
            </div>
          </ContainerDetailsForm>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};
